import script from "./GapClosures.vue?vue&type=script&setup=true&lang=js"
export * from "./GapClosures.vue?vue&type=script&setup=true&lang=js"

import "./GapClosures.vue?vue&type=style&index=0&id=14d1632a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d1632a"]])

export default __exports__